module.exports = __webpack_public_path__ + "media/images/svg/dollar-icon-f42b7fefac27975315683f6ee9bac47e.svg";